import { SiProbot } from "react-icons/si";

const AnaliseDeCreditoBanner = ({ onClick }) => {
  return (
    <div className="flex items-center justify-between gap-4 p-5 rounded-2xl bg-[#66B7A2]/10 border border-[#66B7A2]">
      <div className="flex items-center gap-4">
        <div className="bg-blue-800 text-white rounded-full p-3">
          <SiProbot className="w-6 h-6" />
        </div>
        <div>
          <p className="text-base font-semibold text-[#2D4D44]">
            Decida com segurança e inteligência
          </p>
          <p className="text-sm text-[#3B6258]">
            Ative agora a análise de crédito com IA e receba um parecer técnico
            completo por apenas{" "}
            <span className="font-bold text-[#66B7A2]">R$ 1,50</span>.
          </p>
          <p className="text-sm text-[#3B6258] mt-1 italic">
            Ideal para entender riscos, evitar prejuízos e tomar decisões
            melhores.
          </p>
        </div>
      </div>

      <button
        onClick={onClick}
        className="text-sm font-semibold px-4 py-2 rounded-lg bg-blue-800 text-white hover:bg-[#579d8b] transition"
      >
        Ver análise
      </button>
    </div>
  );
};

export default AnaliseDeCreditoBanner;
